import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-list-item-checkbox',
  templateUrl: './list-item-checkbox.component.html',
  styleUrls: ['./list-item-checkbox.component.css'],
})
export class ListItemCheckboxComponent implements OnInit {
  @Input() id: string;
  @Input() checked: boolean;
  @Output() check = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  onSelect(): void {
    this.check.emit();
  }
}
